import React from 'react';
import css from './BaggageItemIcon.css';
const BaggageItemIcon = () => {
    return React.createElement("div", { className: css.container });
};
export default BaggageItemIcon;
